import { Component, OnInit } from '@angular/core';
import { EducationComponent } from '../education.component';

@Component({
  selector: 'app-touch-talks',
  templateUrl: './talks.component.html',
  styleUrls: ['../education.component.scss']
})
export class EducationTalksComponent extends EducationComponent implements OnInit {
  public ngOnInit(): void {
    super.ngOnInit();
  }
}
